import React, { useState } from "react";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css"; // This only needs to be imported once in your app

const ImageGridLightbox = ({
    images = [] as string[],
    initialIndex = 0,
    onClose = () => {
        return;
    },
    showNextPrevButtons = false,
}) => {
    const [index, setIndex] = useState(initialIndex);

    const onMovePrevRequest = () => {
        setIndex((index + images.length - 1) % images.length);
    };

    const onMoveNextRequest = () => {
        setIndex((index + 1) % images.length);
    };

    return (
        <Lightbox
            mainSrc={images[index]}
            nextSrc={images[(index + 1) % images.length]}
            prevSrc={images[(index + images.length - 1) % images.length]}
            onCloseRequest={onClose}
            onMovePrevRequest={onMovePrevRequest}
            onMoveNextRequest={onMoveNextRequest}
            wrapperClassName={showNextPrevButtons ? "" : "hideNavButtons"}
            reactModalStyle={{
                overlay: {
                    zIndex: "1700",
                },
            }}
        />
    );
};

export default ImageGridLightbox;
